import { render } from "./AppStaffRemarques.vue?vue&type=template&id=30f747a9&scoped=true"
import script from "./AppStaffRemarques.vue?vue&type=script&lang=js"
export * from "./AppStaffRemarques.vue?vue&type=script&lang=js"

import "./AppStaffRemarques.vue?vue&type=style&index=0&id=30f747a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f747a9"]])

export default __exports__